import { render, staticRenderFns } from "./MenDianPurchaseSalesKuCun.vue?vue&type=template&id=7c63c4d2&scoped=true&"
import script from "./MenDianPurchaseSalesKuCun.vue?vue&type=script&lang=js&"
export * from "./MenDianPurchaseSalesKuCun.vue?vue&type=script&lang=js&"
import style0 from "./MenDianPurchaseSalesKuCun.vue?vue&type=style&index=0&id=7c63c4d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63c4d2",
  null
  
)

export default component.exports